export const FlatRatedRent = 'FlatRatedRent';
export const RentBasedOnMinimum = 'RentBasedOnMinimum';
export const CirculatingInventory = 'CirculatingInventory';
export const PieceRateOnly = 'PieceRateOnly';
export const WeeklyUsage = 'WeeklyUsage';

export const FlatRatedRentId = 1;
export const RentBasedOnMinimumId = 2;
export const CirculatingInventoryId = 3;
export const PieceRateOnlyId = 4;
export const WeeklyUsageId = 6;


const BillingMethodKeyValuePairs = {
    1: 'FlatRatedRent', 
    2: 'RentBasedOnMinimum', 
    3: 'CirculatingInventory', 
    4: 'PieceRateOnly', 
    6: 'WeeklyUsage', 
}

export const getBillingMethodById = (id) => BillingMethodKeyValuePairs[id];
export const getBillingMethodIdByName = (name) => Object.keys(BillingMethodKeyValuePairs).find(id => BillingMethodKeyValuePairs[id] === name)
